import type { Ad, SMSContent } from "@models/Ad.model";
import type { AdCardRendererProps } from "../types";

function getText(ad: Ad): string {
    return (ad.content as SMSContent | undefined)?.text ?? "";
}

export default function AdCardSms({ ad, mode }: AdCardRendererProps) {
    const clampClass =
        mode === "compact" ? "adcard-sms__bubble--compact"
        : mode === "full" ? "adcard-sms__bubble--full"
        : "adcard-sms__bubble--detail";

    const text = getText(ad);

    return (
        <div className={`adcard-sms__wrap adcard-sms__wrap--${mode}`}>
            <div className={`adcard-sms__bubble ${clampClass}`}>
                {text || <span className="adcard-sms__empty">(no message)</span>}
            </div>
        </div>
    );
}
